export function createEventListener(object) {
	object = object || {};
	const listeners = {};

	object.on = (eventName, cb, once, context) => {
		if(eventName instanceof Array) {
			eventName.forEach((eventName) => {
				object.on(eventName, cb, once);
			});
		} else {
			if(!listeners[eventName]) {
				listeners[eventName] = [];
			}
			listeners[eventName].push({
				cb: cb,
				once: once,
				context: context
			});
		}
		return object;
	};

	object.once = (eventName, cb, context) => {
		return object.on(eventName, cb, true, context);
	};

	object.trigger = (eventName, args, context) => {
		if(!(args instanceof Array)) {
			args = typeof args != 'undefined' ? [args] : [];
		}
		if(typeof context == 'undefined') {
			context = object;
		}
		if(listeners[eventName]) {
			const onceKey = [];
			listeners[eventName].forEach((listener, index) => {
				try {
					listener.cb.apply(listener.context || context, args);
				} catch(e) {
					console.error('trigger ', (context && context.constructor && context.constructor.name ? context.constructor.name + ': ' : ' ') + eventName, e.message);
				}
				if(listener.once) {
					onceKey.push(index);
				}
			});
			onceKey.forEach((key) => {
				delete listeners[eventName][key];
			});
		}
	};

	return object;
}
